export default "__VITE_ASSET__70f0211e__"